import React from 'react';
import styles from './horizontalLoader.module.css';

const defaultStyles = {
  containerWidth: '100px',
  size: '18px',
  color: '#333'
};

const HorizontalLoader = props => {
  const containerStyle = {
    width: props.containerWidth || defaultStyles.containerWidth
  };
  const dotStyle = {
    width: props.size || defaultStyles.size,
    height: props.size || defaultStyles.size,
    backgroundColor: props.color || defaultStyles.color
  };
  return (
    <div className={styles.spinner} style={containerStyle}>
      <div className={styles.bounce1} style={dotStyle} />
      <div className={styles.bounce2} style={dotStyle} />
      <div className={styles.bounce3} style={dotStyle} />
    </div>
  );
};
export default HorizontalLoader;
